const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the Linkedin Learning Importer Directive to display a list or table with tracks to manage
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Resource} ManageTracks the resource defined to get and set Tracks data
 */
app.directive('linkedinLearningImporter', ['Application', 'ContentIntegrations', '$translate', function (Application, ContentIntegrations, $translate) {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      onImport: '&'
    },
    template: require('../../templates/directives/linkedin-learning-importer.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.translations = {};

      self.content = {
        oneHalf: [],
        twoHalf: []
      };

      function parseQs(link) {            
        var pairs = link.split('?')[1].split('&');
        
        var result = {};
        pairs.forEach(function(pair) {
          pair = pair.split('=');
          result[pair[0]] = decodeURIComponent(pair[1] || '');
        });

        return result;
      };

      self.comms = {
        page_size: 15,
        searchTerm: '',
        lastSearched: '',
        loading: false,
        holdTime: 300,
        throttleHold: null,
        request: function(link) {
          var options = {
            q: 'criteria',
            // 'assetFilteringCriteria.licensedOnly': 'true',
            'assetFilteringCriteria.count': self.comms.page_size,
            'assetFilteringCriteria.fields': 'urn,title,details,type,contents:($*:(asset:(urn,type)))',
            // 'assetPresentationCriteria.targetLocales.language': 'en',
            // 'assetPresentationCriteria.targetLocales.country': 'US',
            'assetRetrievalCriteria.expandDepth': 1,
            // 'assetFilteringCriteria.assetTypes[0]': 'COURSE'
            // 'assetFilteringCriteria.assetTypes[1]': 'VIDEO',
            // 'assetFilteringCriteria.assetTypes[2]': 'LEARNING_PATH'
          };

          if (self.comms.searchTerm) {
            options['assetFilteringCriteria.keyword'] = self.comms.searchTerm;
          }

          var langBlock = {
            en: {
              language: 'en',
              country: 'US'
            },
            de: {
              language: 'de',
              country: 'DE'
            },
            ja: {
              language: 'ja',
              country: 'JP'
            },
            fr: {
              language: 'fr',
              country: 'FR'
            },
            es: {
              language: 'es',
              country: 'ES'
            }
          };

          if (self.searchOptions.currentSettings && self.searchOptions.currentSettings.language) {
            var lang = self.searchOptions.currentSettings.language;
            if (langBlock[lang]) {
              options['assetFilteringCriteria.locale.language[0]'] = langBlock[lang].language || 'en';
              options['assetPresentationCriteria.targetLocale.language'] = langBlock[lang].language || 'en';
              options['assetFilteringCriteria.locale.country[0]'] = langBlock[lang].country || 'US';
              options['assetPresentationCriteria.targetLocale.country'] = langBlock[lang].country || 'US';
            }
          }

          options = Object.assign(self.searchOptions.currentSettings, options);
          delete options.language;

          options['assetFilteringCriteria.locale.language[0]'] = options['assetFilteringCriteria.locale.language[0]'] || 'en';
          options['assetPresentationCriteria.targetLocale.language'] = options['assetPresentationCriteria.targetLocale.language'] || 'en';
          options['assetFilteringCriteria.locale.country[0]'] = options['assetFilteringCriteria.locale.country[0]'] || 'US';
          options['assetPresentationCriteria.targetLocale.country'] = options['assetPresentationCriteria.targetLocale.country'] || 'US';
          options['assetFilteringCriteria.assetTypes[0]'] = options['assetFilteringCriteria.assetTypes[0]'] || 'COURSE';

          if (link) {
            options = parseQs(link);
          }

          return ContentIntegrations.searchContent({name: 'linkedin_learning'}, options).$promise;

        },
        load: function(immediate, link) {
          var time = immediate ? 1 : self.comms.holdTime;
          if (self.comms.throttleHold) {
            window.clearTimeout(self.comms.throttleHold);
          }
          self.comms.loading = true;
          self.comms.throttleHold = setTimeout(function() {
            self.comms.request(link)
            .then(function(body) {
              self.comms.previousLink = null;
              self.comms.nextLink = null;
              if (body.paging && body.paging.links) {
                body.paging.links.forEach(function(item) {
                  if (!item.rel) {
                    return;
                  }
                  if (item.rel === 'next') {
                    self.comms.nextLink = item.href;
                  }
                  if (item.rel === 'prev') {
                    self.comms.previousLink = item.href;
                  }
                });

              }

              self.content.oneHalf = body.elements;
              self.content.twoHalf = [];
              self.selection.course = null;
              self.comms.loading = false;
              window.scrollTo(0, 0);
            }).catch(function(error) {
              self.comms.loading = false;
            });
            self.comms.throttleHold = null;
          }, time);
        },
        searchChange: function() {
          if (self.comms.searchTerm.length === 1) {
            return;
          }
          self.comms.lastSearched = self.comms.searchTerm;
          self.comms.page = 1;
          self.comms.load();
        }
      };

      self.searchOptions = {
        currentSettings: {},
        typeOptions: [],
        showType: false,
        typeName: null,
        typeChange: function(item) {
          self.searchOptions.currentSettings['assetFilteringCriteria.assetTypes[0]'] = item.value;
          if (!item.value) {
            delete self.searchOptions.currentSettings['assetFilteringCriteria.assetTypes[0]'];
          }
          self.searchOptions.typeName = item.value ? item.name : '';
          self.searchOptions.showType = false;
          self.comms.load();
        },
        sortOptions: [],
        showSort: false,
        sortName: null,
        sortChange: function(item) {
          self.searchOptions.currentSettings['assetPresentationCriteria.sortBy'] = item.value;
          if (!item.value) {
            delete self.searchOptions.currentSettings['assetPresentationCriteria.sortBy'];
          }
          self.searchOptions.sortName = item.value ? item.name : '';
          self.searchOptions.showSort = false;
          self.comms.load();
        },
        difficultyOptions: [],
        showDifficulty: false,
        difficultyName: null,
        difficultyChange: function(item) {
          self.searchOptions.currentSettings['assetFilteringCriteria.difficultyLevels[0]'] = item.value;
          if (!item.value) {
            delete self.searchOptions.currentSettings['assetFilteringCriteria.difficultyLevels[0]'];
          }
          self.searchOptions.difficultyName = item.value ? item.name : '';
          self.searchOptions.showDifficulty = false;
          self.comms.load();
        },
        durationOptions: [],
        showDuration: false,
        durationName: null,
        durationChange: function(item) {
          self.searchOptions.currentSettings.duration = item.value;
          if (!item.value) {
            delete self.searchOptions.currentSettings.duration;
          }
          self.searchOptions.durationName = item.value ? item.name : '';
          self.searchOptions.showDuration = false;
          self.comms.load();
        },
        languageOptions: [],
        showLanguage: false,
        languageName: null,
        languageChange: function(item) {
          self.searchOptions.currentSettings.language = item.value;
          if (!item.value) {
            delete self.searchOptions.currentSettings.language;
          }
          self.searchOptions.languageName = item.value ? item.name : '';
          self.searchOptions.showLanguage = false;
          self.comms.load();
        }
      };

      self.selection = {
        course: null,
        loading: false,
        select: function(index, item, half) {
          if (index === 'cancel' || self.selection.course && self.selection.course.urn && item.urn && item.urn === self.selection.course.urn) {
            self.content.oneHalf = self.content.oneHalf.concat(self.content.twoHalf);
            self.content.twoHalf = [];
            self.selection.course = null;
            return;
          }
          self.selection.course = item;
          if (!item.urn) {
            // Handle error
            return;
          }
          var calculatedIndex = half === 1 ? index : self.content.oneHalf.length + index;
          self.content.oneHalf = self.content.oneHalf.concat(self.content.twoHalf);
          self.content.twoHalf = self.content.oneHalf.splice(calculatedIndex + 1);
          self.selection.loading = true;
          self.selection.course = item;
        },
        importCourse: function(item) {
          if (!item || !item.urn) {
            return;
          }
          self.comms.loading = true;
          $scope.onImport({item: {vendor: 'linkedin_learning', course: item.urn}});
          Application.scrollTop();
          setTimeout(function() {
            self.comms.loading = false;
          }, 5);
        },
        getDuration: function(item) {
          if (!item || !item.details || !item.details.timeToComplete || !item.details.timeToComplete.duration) {
            return;
          }
          var time = item.details.timeToComplete.duration;
          if (!item.details.timeToComplete.unit || item.details.timeToComplete.unit === 'SECOND') {
            if (time && time < 60) {
              return self.translations['fileviewer.less_than_a_minute'];
            }
            var mins = ~~(time / 60);
            var secs = time % 60;

            var hrs = ~~(time / 3600);
            var mins = ~~((time % 3600) / 60);
            var secs = time % 60;

            var ret = "";

            if (hrs > 0) {
              ret += "" + hrs + (hrs === 1 ? " hr" : " hrs") + " ";
            }

            ret += "" + mins + (mins === 1 ? " min" : " mins");

            return ' - ' + ret;
          }

          return'';
        }
      };

      self.initialize = function() {
        self.comms.load(true);
      };

      $translate([
        'global.contentTypes.video',
        'edit.importedcontent.course',
        'edit.importedcontent.learning_path',
        'edit.importedcontent.clear',
        'edit.importedcontent.short',
        'edit.importedcontent.medium',
        'edit.importedcontent.long',
        'edit.importedcontent.extra_long',
        'edit.importedcontent.beginner',
        'edit.importedcontent.intermediate',
        'edit.importedcontent.advanced',
        'edit.importedcontent.relevance',
        'edit.importedcontent.most_popular',
        'edit.importedcontent.most_recent',
        'English',
        'German',
        'Spanish',
        'language.japanese',
        'language.french',
        'fileviewer.less_than_a_minute'
      ]).then(function(translations) {
        self.translations = translations;
        self.searchOptions.typeOptions = [
          {name: self.translations['global.contentTypes.video'], value: 'VIDEO'},
          {name: self.translations['edit.importedcontent.course'], value: 'COURSE'},
          {name: self.translations['edit.importedcontent.learning_path'], value: 'LEARNING_PATH'},
          {name: self.translations['edit.importedcontent.clear'], value: null}
        ];
        self.searchOptions.sortOptions = [
          {name: self.translations['edit.importedcontent.relevance'], value: 'RELEVANCE'},
          {name: self.translations['edit.importedcontent.most_recent'], value: 'RECENCY'},
          {name: self.translations['edit.importedcontent.most_popular'], value: 'POPULARITY'},
          {name: self.translations['edit.importedcontent.clear'], value: null}
        ];
        self.searchOptions.difficultyOptions = [
          {name: self.translations['edit.importedcontent.beginner'], value: 'BEGINNER'},
          {name: self.translations['edit.importedcontent.intermediate'], value: 'INTERMEDIATE'},
          {name: self.translations['edit.importedcontent.advanced'], value: 'ADVANCED'},
          {name: self.translations['edit.importedcontent.clear'], value: null}
        ];
        self.searchOptions.durationOptions = [
          {name: self.translations['edit.importedcontent.short'], value: 'short'},
          {name: self.translations['edit.importedcontent.medium'], value: 'medium'},
          {name: self.translations['edit.importedcontent.long'], value: 'long'},
          {name: self.translations['edit.importedcontent.extra_long'], value: 'extraLong'},
          {name: self.translations['edit.importedcontent.clear'], value: null}
        ];
        self.searchOptions.languageOptions = [
          {name: self.translations['English'], value: 'en'},
          {name: self.translations['German'], value: 'de'},
          {name: self.translations['language.japanese'], value: 'ja'},
          {name: self.translations['language.french'], value: 'fr'},
          {name: self.translations['Spanish'], value: 'es'}
        ];
        self.initialize();
      });
    }],
    controllerAs: 'lil'
  }
}]);